import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Styles from "../../Styles/Resume.module.css"
import edit from "../../Assets/edit.png"
import del from "../../Assets/delete.png";
import add from "../../Assets/add.png";


const Links = () => {
    const [workLink, setWorkLink] = useState([
      {
        Link1: 'https://github.com',
        Link2: 'WWW.LOG',
        Link3: 'LIA',
        Link4: 'GG',
        
      },
    ]);
  
    const [newWorkLink, setNewWorkLink] = useState({
      Link1: '',
      Link2: '',
      Link3: '',
      Link4: '',

    });
  
    const handleAddWorkLink = () => {
      setWorkLink([...workLink, newWorkLink]);
      setNewWorkLink({
        Link1: '',
        Link2: '',
        Link3: '',
        Link4: '',
  
      });
    };
  
    const handleEditWorkLink = (index) => {
      const updatedWorkLink = [...workLink];
      updatedWorkLink[index] = newWorkLink;
      setWorkLink(updatedWorkLink);
    };
  
    const handleDeleteWorkLink = (index) => {
      const updatedWorkLink = [...workLink];
      updatedWorkLink.splice(index, 1);
      setWorkLink(updatedWorkLink);
    };

    const [modalOpen,  setModalOpen  ] = useState(false)

    const handleCloseModal = () => {
      setModalOpen(false);
    };
   
   
  
    return (
        <div className={Styles.contents6}>
{workLink.map((link, index) => ( 
<><div key={index} className={Styles.subcontent}>
        <div className={Styles.subcontent1}>
            <h1 style={{ whiteSpace: "nowrap" }}>Links</h1>
        </div>
        <div className={Styles.subcontent2}>
            <img src={add}onClick={() => setModalOpen(true)}  alt="/" width="23.0px" height="23.0px" />
        </div>
    </div><div className={Styles.subcontent01}>
            <hr style={{ width: "605px" }}></hr>
        </div><div className={Styles.subcontent02}>
            <div className={Styles.subcontent1}>
                <div className={Styles.text}>
            <div className={Styles.headertext} style={{ display:"flex" , gap:"75px"}}>
                        <Link style={{ whiteSpace: "nowrap", color: "rgba(233, 136, 98, 1)" }}>{link.Link1}</Link>
                        <Link style={{ whiteSpace: "nowrap", color: "rgba(233, 136, 98, 1)" }}>{link.Link2}</Link>
                        <Link style={{ whiteSpace: "nowrap", color: "rgba(233, 136, 98, 1)" }}>{link.Link3}</Link>
                        <Link style={{ whiteSpace: "nowrap", color: "rgba(233, 136, 98, 1)" }}>{link.Link4}</Link>
                        <div className={Styles.icon} style={{ whiteSpace: "nowrap" }}>
                            <img src={edit} alt="/" width="23.0px" height="23.0px" style={{ position: 'relative', right: "30px" }} onClick={() => handleEditWorkLink()}   />
                            <img src={del} alt="/" width="20.0px" height="20.0px" onClick={() => handleDeleteWorkLink(index)} />
                        </div>
                    </div>
                </div>
            </div>
        </div></>

         ))}
        

      {modalOpen && <div id={Styles.ModalContainer} >
        <div id={Styles.Modal}  >
        <label>Link 1</label>
          <input type="text" value={newWorkLink.Link1} onChange={(e) => setNewWorkLink({ ...newWorkLink, Link1: e.target.value })} />
          <label>Link 2</label>
          <input type="text" value={newWorkLink.Link2} onChange={(e) => setNewWorkLink({ ...newWorkLink, Link2: e.target.value })} />
          <label>Link 3</label>
          <input type="text" value={newWorkLink.Link3} onChange={(e) => setNewWorkLink({ ...newWorkLink, Link3: e.target.value })} />
          <label>Link 4</label>
          <input type="text" value={newWorkLink.Link4} onChange={(e) => setNewWorkLink({ ...newWorkLink, Link4: e.target.value })} />
          <button onClick={handleAddWorkLink} className={Styles.btn1}>Add</button>
            <button onClick={handleCloseModal} className={Styles.btn2}>close</button>
        </div>
        </div>}
            </div>
    );
  }
export default Links;